import { Box, Link, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useGetStructureDataQuery, Structure, StructureStatus } from '@/__generated__/graphql';
import { useRouter } from '@/hooks';
import { useEffect, useState } from 'react';
import { useSetAtom } from 'jotai';
import * as state from '@/components/Analysis/state';

interface StructureWithPlatform extends Omit<Structure, 'status' | 'platform'> {
  status: StructureStatus;
  platform?: {
    id: string;
  } | null;
  isActive?: boolean; // For backward compatibility
}

export const DeploymentBanner = ({ structureId }: { structureId: string }) => {
  const setstructurePipes = useSetAtom(state.structurePipesByStructureId);
  const router = useRouter();
  const { data: structureData } = useGetStructureDataQuery({
    variables: { structureId },
    fetchPolicy: 'cache-first',
    skip: !structureId,
  });

  useEffect(() => {
    const structurePipes = structureData?.structure?.structurePipesConfig?.imperialSteelPipes;
    if (structureId && structurePipes) {
      setstructurePipes(() => ({
        [structureId]: structurePipes as Record<string, number>,
      }));
    }
  }, [
    setstructurePipes,
    structureId,
    structureData?.structure?.structurePipesConfig?.imperialSteelPipes,
  ]);
  const [open, setOpen] = useState(true);
  const structure = structureData?.structure as StructureWithPlatform | undefined;
  const platformId = structure?.platform?.id;
  // Treat isActive as false if it is null or undefined
  const isActive = structure?.isActive === true;

  if (!platformId || !open || isActive) return null;

  return (
    <Box
      sx={{
        width: '100%',
        backgroundColor: '#eab308',
        borderBottom: '1px solid #FFB74D',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '8px',
        fontSize: '14px',
        color: '#3E2723',
        paddingTop: '5px',
        fontWeight: 500,
        position: 'relative',
        height: '30px',
      }}
    >
      <Box component="span">You’re currently viewing an older deployment.</Box>
      <Link
        href={`/platform-assets/${platformId}`}
        onClick={(e) => {
          e.preventDefault();
          router.push(`/platform-assets/${platformId}`);
        }}
        sx={{
          color: '#1976d2',
          textDecoration: 'underline',
          '&:hover': { textDecoration: 'none' },
          fontWeight: 500,
          marginLeft: '4px',
          marginRight: '4px',
        }}
      >
        Click here
      </Link>
      to go to the Platform Assets Page .
      <IconButton
        aria-label="close"
        size="small"
        onClick={() => setOpen(false)}
        sx={{
          position: 'absolute',
          right: 8,
          top: '50%',
          transform: 'translateY(-50%)',
          color: '#3E2723',
        }}
      >
        <CloseIcon fontSize="small" />
      </IconButton>
    </Box>
  );
};
